import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    allClubs,
    allTournamentList,
    fetchTournamentList,
    editTournamentScore,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        this.props.allTournamentList();
        this.props.allClubs();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            club:this.props.data.club, 
            student:this.props.data.student,
            country:this.props.data.country,
            student:this.props.data.student,
            round1date:new Date(this.props.data.round1date),
            round2date:new Date(this.props.data.round2date),
            round3date:new Date(this.props.data.round3date),
            round4date:new Date(this.props.data.round4date),
            view1:this.props.data.view1,
            view2:this.props.data.view2,
            view3:this.props.data.view3,
            view4:this.props.data.view4,
            missedcut:this.props.data.missedcut,
            tournamentval:this.props.data.tournament, 
            position:this.props.data.position, 
            editable: {}
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }

    selclub = (evt) =>{
        var tournmentid =evt.value;
        this.setState({ tournamentval:tournmentid });

        this.props.fetchTournamentList(tournmentid).then((data) => {   
            var resdata=data.data;
            this.setState({ 
                club:resdata[0].gtl_course,
                country:resdata[0].gtl_country, 
                round1date:new Date(resdata[0].gtl_date),
            });

            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
            });

        });
    }

    selRound(evt){
        var round=evt.target.value;
        if(round==1){
            this.setState({ 
                view1:true,  
                view2:false,
                view3:false, 
                view4:false,    
            });
        }else if(round==2){
            this.setState({ 
                view1:true,  
                view2:true,
                view3:false, 
                view4:false,    
            });
        }else if(round==3){
            this.setState({ 
                view1:true,  
                view2:true,
                view3:true, 
                view4:false,    
            });
        }else if(round==4){
            this.setState({ 
                view1:true,  
                view2:true,
                view3:true, 
                view4:true,    
            });
        }

    }

    selectdate = (date, id) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        if(id==1){
            this.setState({ round1date:date });
        }else if(id==2){
            this.setState({ round2date:date });
        }else if(id==3){
            this.setState({ round3date:date });
        }else if(id==4){
            this.setState({ round4date:date });
        }
    }    

    addHandleSubmit(event){
        event.preventDefault();
        
        this.props.editTournamentScore(event).then((data) => {   
        
           
        });
        setTimeout(() => {
            this.props.onClick();
        }, 2000);                       
        
    } 
    
    handleChange(e) {                  
           
        var checkval=e.target.value;
        if(checkval==1){                
            this.setState({ missedcut:0,position:0 }); 
            this.setState(({ editable }) => ({
                editable: { ...editable, ['possition']: !editable['possition'] }
            }));
        }else{               
            this.setState({ missedcut:1,position:1 }); 
            this.setState(({ editable }) => ({
                editable: { ...editable, ['possition']: !editable['possition'] }
            }));
        }       

    }


render() {

    const { studentlists, tournamentalllist, clublist, tournamentscoredetails, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
            return {
            label: stdval.student,  
            value: stdval.uudID
            }
    });

    const allclub=clublist.map((stdval) => {  
        return {
        label: stdval.ccb_clubName,  
        value: stdval.ccb_clubID
        }
    });

    const alltournament=tournamentalllist.map((stdval) => {  
        return {
           label: stdval.gtl_name,  
           value: stdval.gtlID
        }
    });
   
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-6" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Edit Tournament Score">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-md-7"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                        </div> 
                                        <div className="col-sm-12 col-md-6">
                                                <Label for="course">Tournament *</Label>
                                                <FormGroup>
                                                <Label for="course">Tournament *</Label>
                                                    <Selectsearch placeholder="Select the tournament" id="tournament" name="tournament" options={alltournament} value={alltournament.find(obj => obj.value == this.state.tournamentval)} onChange={this.selclub} required/>
                                                </FormGroup>
                                        </div>  
                                        <div className="col-sm-12 col-md-6">
                                                <Label for="course">Course *</Label>
                                                <FormGroup>
                                                    <Label for="course">Course *</Label>
                                                    <Selectsearch placeholder="Select the course" id="course" name="course" rules={{ required: 'Please select course'}} options={allclub} value={allclub.find(obj => obj.value === this.state.club)} required/>
                                                </FormGroup>                       
                                        </div> 
                                         
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="country">Country *</Label>
                                                <input type="text" name="country" id="country" className="form-control form-control-alternative" defaultValue={this.state.country} required/>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="Select">Round *</Label>
                                                    <select name="round" id="round" className="form-control form-control-alternative" defaultValue={tournamentscoredetails[0].gtr_round} onChange={e => this.selRound(e)} required>
                                                         
                                                          <option value="1">1</option>
                                                          <option value="2">2</option>
                                                          <option value="3">3</option> 
                                                          <option value="4">4</option>                                                         
                                                    </select>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="country">Position</Label>
                                                <input type="text" name="position" id="position" disabled={(this.state.position==1)?!this.state.editable['position']:this.state.editable['position']} defaultValue={(tournamentscoredetails[0].gtr_misscut==0)?tournamentscoredetails[0].gtr_position:''} className="form-control form-control-alternative"/>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="country">Missed Cut </Label>
                                                <input type="checkbox" name="missedcut" id="missedcut" defaultChecked={tournamentscoredetails[0].gtr_misscut==1?true:false} className="form-control form-control-alternative" onChange={e => this.handleChange(e)} value={this.state.missedcut}/>
                                            </FormGroup>  
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <div className="table-responsive">
                                                <Table>
                                                    <TableHead>
                                                        <TableRow hover>                                                           
                                                            <TableCell align="center">#</TableCell>
                                                            <TableCell align="center">SCORE</TableCell>
                                                            <TableCell align="center">SCORE DATE</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.view1 &&
                                                        <TableRow>
                                                            <TableCell>Round 1</TableCell>
                                                            <TableCell>
                                                            <input type="text" name="roundscore_1" id="roundscore_1" defaultValue={tournamentscoredetails[0].gtr_rd1} className="form-control form-control-alternative" required/>
                                                            </TableCell>
                                                            <TableCell>
                                                                <DatePicker className="form-control form-control-alternative" name="rounddate_1" id="rounddate_1" required autoComplete="off" 
                                                                selected={this.state.round1date}
                                                                onChange={e => this.selectdate(e, 1)}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                            </TableCell>
                                                        </TableRow>  
                                                        }
                                                        {this.state.view2 &&
                                                        <TableRow>
                                                            <TableCell>Round 2</TableCell>
                                                            <TableCell>
                                                            <input type="text" name="roundscore_2" id="roundscore_2" defaultValue={tournamentscoredetails[0].gtr_rd2} className="form-control form-control-alternative" required/>
                                                            </TableCell>
                                                            <TableCell>
                                                                <DatePicker className="form-control form-control-alternative" name="rounddate_2" id="rounddate_2" required autoComplete="off" 
                                                                selected={this.state.round2date}
                                                                onChange={e => this.selectdate(e, 2)}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                            </TableCell>
                                                        </TableRow>  
                                                        }
                                                        {this.state.view3 &&
                                                        <TableRow>
                                                            <TableCell>Round 3</TableCell>
                                                            <TableCell>
                                                            <input type="text" name="roundscore_3" id="roundscore_3" defaultValue={tournamentscoredetails[0].gtr_rd3} className="form-control form-control-alternative" required/>
                                                            </TableCell>
                                                            <TableCell>
                                                                <DatePicker className="form-control form-control-alternative" name="rounddate_3" id="rounddate_3" required autoComplete="off" 
                                                                selected={this.state.round3date}
                                                                onChange={e => this.selectdate(e, 3)}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                            </TableCell>
                                                        </TableRow>  
                                                        }
                                                        {this.state.view4 &&
                                                        <TableRow>
                                                            <TableCell>Round 4</TableCell>
                                                            <TableCell>
                                                            <input type="text" name="roundscore_4" id="roundscore_4" defaultValue={tournamentscoredetails[0].gtr_rd4} className="form-control form-control-alternative" required/>
                                                            </TableCell>
                                                            <TableCell>
                                                                <DatePicker className="form-control form-control-alternative" name="rounddate_4" id="rounddate_4" required autoComplete="off" 
                                                                selected={this.state.round4date}
                                                                onChange={e => this.selectdate(e, 4)}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                            </TableCell>
                                                        </TableRow>  
                                                        }          
                                                    </TableBody>                                                    
                                                </Table>   
                                            </div>  
                                            </div>       
                                        </div>
                                       <div className="col-md-12">
                                        <div className="form-group">
                                        <input type="hidden" name="oldid" id="oldid" value={tournamentscoredetails[0].gtrID} /> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, tournamentlist, tournamentscore}) => {
    const { studentlists, clublist, loading } = mostlyused;
    const { tournamentalllist } = tournamentlist;
    const { tournamentscoredetails } = tournamentscore;
    return { studentlists, tournamentalllist, clublist, tournamentscoredetails, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    allClubs,
    allTournamentList,
    fetchTournamentList,
    editTournamentScore,
})(EditItems);
